import React from 'react';
import {withRouter, Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import * as R from 'ramda';
import {withTranslation} from 'react-i18next';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Image from 'react-bootstrap/Image';

import {
  ROOT_ROUTE,
  NEWS_ROUTE,
  CONTESTS_ROUTE,
  FAQ_ROUTE,
  UserNav,
  LangNav,
} from 'Internal';

import LogoPNG from 'Assets/icons/logo.svg';


class DefaultHeader extends React.Component {

  render() {
    const {
      t,
    } = this.props;

    return (
      <Navbar
        className="pb-5 pt-3"
        expand="md"
      >
        <Container>
          <Navbar.Brand>
            <Link className="text-decoration-none" to={ROOT_ROUTE}>
              <Image
                className="header-logo"
                src={LogoPNG}
                fluid
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle/>
          <Navbar.Collapse className="justify-content-end" >
            <Nav>
              <Nav.Link to={CONTESTS_ROUTE} as={Link}>{t('Competitions')}</Nav.Link>
              <Nav.Link to={NEWS_ROUTE} as={Link}>{t('News')}</Nav.Link>
              <Nav.Link to={FAQ_ROUTE} as={Link}>FAQ</Nav.Link>
              <UserNav/>
              <LangNav/>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

function applyContext(WrappedComponent) {
  const injectContext = R.pipe(
    observer,
    inject('stores'),
    withRouter,
    withTranslation(['header']),
  );
  return injectContext(WrappedComponent);
}

export default applyContext(DefaultHeader);
